// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// libraries
import User from '../lib/User.js'

class DestinationsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      companies: [],
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  componentDidMount() {
    User.watch(this, () => {
      this.loadCompanies()
    })
  }

  loadCompanies = () => {
    window._api.get('/companies', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      this.setState({ companies: resp.items })
    })
  }

  render() {
    let { companies, modalOpen } = this.state

    return (
      <div id="destinations-page">
        <Header
          title="Destinations"
          actions={[
            {
              children: 'Create New Destination',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              key: 'name',
              link: '/destinations/:_id',
              sortable: true,
            },
            {
              key: 'slug',
              link: '/destinations/:_id',
              sortable: true,
            },
            {
              key: 'mapping_id.name',
              link: `/mapping-ids/:mapping_id._id`,
              name: 'Mapping ID',
            },
            {
              key: 'salesforce_integration_partner.name',
              link: `/salesforce-integration-partners/:salesforce_integration_partner._id`,
              name: 'Salesforce Partner',
            },
            {
              key: 'api_integration',
              link: '/destinations/:_id',
              sortable: true,
              name: 'API Integration',
            },
          ]}
          entities="destinations"
          fields={[
            'name',
            'slug',
            'mapping_id.name',
            'salesforce_integration_partner.name',
            'api_integration',
          ]}
          filters={[{ name: 'company', options: companies }]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="destinations"
            title="Enter a name for your new Destination"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default DestinationsPage
